var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},_vm._l((Object.keys(_vm.databases)),function(db){return _c('div',{staticClass:"col-xs-3"},[_c('CardStatusReplication',{attrs:{"database":db,"label":_vm.databases[db]}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ae8f80c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StatusReplication/IndexStatusReplication.vue
// module id = C4ex
// module chunks = 10